<red-toolbar-institutional
  [type]="(toolbarType$ | async)"
  [menu]="(toolbarMenu$ | async)"
  [user]="(user$ | async)"
  class="c-toolbar-institutional">
</red-toolbar-institutional>

<main class="c-main" id="inicio">

  <article class="c-main__content"
           [@routerAnimations]="prepareRoute(outlet)">

    <router-outlet #outlet="outlet"></router-outlet>
  </article>

  <red-footer class="c-main__footer"></red-footer>
</main>
